import React from 'react'
import loadable from '@loadable/component'
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {routes as _routes} from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />
const LeftNavLayout = loadable(() => import('./components/left-nav-layout'), {fallback})
const LeftNav = loadable(() => import('./components/left-nav'), {fallback})

const CustomerServiceContent = loadable(() => import('./pages/content/customer-service/help'), {
    fallback
})
const ContactUsContent = loadable(() => import('./pages/content/customer-service/contact-us'), {
    fallback
})
const FaqsContent = loadable(() => import('./pages/content/customer-service/faqs'), {fallback})
const ContentWithToggleNav = loadable(() => import('./pages/content/content-left-nav'), {fallback})

const CustomerService = () => (
    <ContentWithToggleNav
        contentPath="content/ca-customerservice-landing"
        Component={CustomerServiceContent}
    />
)
const ContactUs = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <ContactUsContent />
    </LeftNavLayout>
)
const Faqs = () => <ContentWithToggleNav contentPath="content/faqs" Component={FaqsContent} />

const CustomerServiceRoutes = [
    {
        path: '/contactus/',
        component: ContactUs,
        exact: true
    },
    {
        path: '/help/',
        component: CustomerService,
        exact: true
    },
    {
        path: '/content/faqs.html',
        component: Faqs,
        exact: true
    }
]

export default CustomerServiceRoutes
